// KAN-560 Day 3 item 14 (Paul 14628): the learner-facing name of the chat at /learn/agent.
//
// The page said "Capability agent" and the nav said "Agent"; the product calls it the AI
// Companion (Paul's wording on the About-you screen: "Things you told the AI Companion about
// yourself"). One place for the name, so the page title, the nav link and the strings that name
// it cannot drift apart. The other strings are the page's existing sentences with "agent"
// replaced by the product's name (copy for Paul to confirm, listed in the round notes).
export const COMPANION_NAME = 'AI Companion';
export const COMPANION_NAV_LABEL = 'Companion';

export const COMPANION_COPY = {
  title: COMPANION_NAME,
  speaker: 'Companion',
  notSwitchedOn: 'The AI Companion is not switched on for this environment yet.',
  // KAN-560 Day 4 #5 (Paul 14658): the header is per age group (HEADER_BY_AGE below); these two
  // are the adult (A3) lines, kept for any caller that does not know the age group.
  intro:
    'Ask about your capabilities, your work, or where you want to get to. If you tell it what '
    + 'you do, it can draw on capability data for your sector.',
  placeholder: 'Tell the Companion about your work, or ask it something.',
  // Before the age group is known (no wording that assumes work or school).
  placeholderLoading: 'Ask the Companion something.',
  quota: 'You have reached the Companion quota for now. Give it a moment.',
  failed: 'Something went wrong reaching the Companion. Try again in a moment.',
  // The existing "Sector data used — …" line, now with the sector's name only (no counts).
  sectorUsed: (sector) => `Sector data used — ${sector}`,
};

// KAN-560 Day 4 #5 (Paul 14658): the header was written for working adults ("capability data for
// your sector", "try starting with 'I work as…'"), and it said "It only remembers things you tell
// it", which stopped being true when the Companion began reading the learner's answers to the
// week's challenges. One header per journey age group (A1 13-17 at school, A2 university age, A3
// working adults), each saying what is true: it remembers what you tell it about yourself, it can
// read your answers to this week's challenges, and it does not score them.
// PLACEHOLDER: wording from Paul (all three).
// KAN-560 14661 (Paul): A2 and A3 are fine. A1 says "It doesn't score them; that's done
// separately.", so a 13-17 learner does not read it as "my answers aren't scored" once scoring is
// on. A1's "It remembers what you tell it about yourself" is true today: after guardian approval a
// 13-17 learner's facts and message are stored (capability_graph.store_memory; only the reply text
// is dropped when their challenge answers were in the prompt). Register item 51 (Ricardo, storage
// for 13-17) is still open; if he rules no storage, this line changes with that ruling.
export const HEADER_BY_AGE = {
  A1: {
    intro: 'Ask about this week\u2019s challenges, what you\u2019re learning at school, or what '
      + 'you want to get better at.',
    hint: 'It remembers what you tell it about yourself, and it can read your answers to this '
      + 'week\u2019s challenges. It doesn\u2019t score them; that\u2019s done separately. '
      + 'Try starting with '
      + '\u201cAt school I\u2019m studying\u2026\u201d or \u201cI find it hard to\u2026\u201d.',
    placeholder: 'Tell the Companion what you\u2019re studying, or ask it something.',
  },
  A2: {
    intro: 'Ask about this week\u2019s challenges, your studies, or where you want to get to.',
    hint: 'It remembers what you tell it about yourself, and it can read your answers to this '
      + 'week\u2019s challenges. It doesn\u2019t score them. Try starting with '
      + '\u201cI\u2019m studying\u2026\u201d or \u201cI struggle with\u2026\u201d.',
    placeholder: 'Tell the Companion about your studies, or ask it something.',
  },
  A3: {
    intro: COMPANION_COPY.intro,
    hint: 'It remembers what you tell it about yourself, and it can read your answers to this '
      + 'week\u2019s challenges. It doesn\u2019t score them. Try starting with '
      + '\u201cI work as\u2026\u201d or \u201cI struggle with\u2026\u201d.',
    placeholder: COMPANION_COPY.placeholder,
  },
};

/** The header for a journey age group. Unknown (no birth year on file, or outside 13-45): the
 * adult header. A 13-17 learner always has a birth year (the guardian gate needs it). */
export function companionHeader(ageGroup) {
  return HEADER_BY_AGE[ageGroup] || HEADER_BY_AGE.A3;
}
